import { forwardRef, ReactNode } from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import { ButtonAnimate } from '../animate';

interface MIconButtonProps extends IconButtonProps {
  children?: ReactNode;
}

const MIconButton = forwardRef<HTMLButtonElement, MIconButtonProps>(({ children, ...other }, ref) => (
  <ButtonAnimate>
    <IconButton ref={ref} {...other}>
      {children}
    </IconButton>
  </ButtonAnimate>
));

export default MIconButton;
